import Button from "../comman/Button";
import "./ReportModal.css";

const REPORT_REASONS = {
    spam: ["Scam", "Fake account", "Misleading"],
    hate: ["Hate speech", "Harassment", "Threats"],
    violence: ["Physical harm", "Weapons", "Dangerous acts"],
};

const ReportModal = ({
    show,
    step,
    reason,
    subReason,
    setReason,
    setSubReason,
    onNext,
    onBack,
    onSubmit,
    onClose,
    loading,
}) => {
    if (!show) return null;

    return (
        <div className="modal fade show fb-modal-backdrop" style={{ display: "block" }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content fb-report-modal">

                    {/* HEADER */}
                    <div className="modal-header align-items-center">
                        <div className="d-flex align-items-center gap-2">
                            {step === 2 && (
                                <button
                                    className="btn btn-light fb-back-btn"
                                    onClick={onBack}
                                >
                                    ←
                                </button>
                            )}

                            <h5 className="report-modal-title mb-0">Report post</h5>
                        </div>

                        <button type="button" className="btn-close" onClick={onClose} />
                    </div>

                    {/* BODY */}
                    <div className="modal-body">
                        {step === 1 && (
                            <>
                                <p className="fb-subtitle">Why are you reporting this post?</p>

                                {Object.keys(REPORT_REASONS).map(r => (
                                    <button
                                        key={r}
                                        className={`fb-option ${reason === r ? "active" : ""}`}
                                        onClick={() => setReason(r)}
                                    >
                                        {r.replace(/^\w/, c => c.toUpperCase())}
                                    </button>
                                ))}
                            </>
                        )}

                        {step === 2 && (
                            <>
                                <p className="fb-subtitle">Give us more details</p>

                                {REPORT_REASONS[reason].map(sr => (
                                    <button
                                        key={sr}
                                        className={`fb-option ${subReason === sr ? "active" : ""}`}
                                        onClick={() => setSubReason(sr)}
                                    >
                                        {sr}
                                    </button>
                                ))}
                            </>
                        )}
                    </div>

                    {/* FOOTER */}
                    <div className="modal-footer report-modal-footer">
                        <Button
                            text="Cancel"
                            className="btn btn-light rounded-pill"
                            isHideIcon={true}
                            onClick={onClose}
                        />

                        {step === 1 && (
                            <Button
                                text="Next"
                                className="button"
                                isHideIcon={true}
                                disabled={!reason}
                                onClick={onNext}
                            />
                        )}

                        {step === 2 && (
                            <Button
                                text="Submit"
                                className="button"
                                isHideIcon={true}
                                disabled={!subReason || loading}
                                onClick={onSubmit}
                            />
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ReportModal;
